const cacheKey = {};

export const jobKeys = {
  all: ['jobs'],
  lists: () => [...jobKeys.all, 'list'],
  list: (filters) => [...jobKeys.lists(), {filters}],
  details: () => [...jobKeys.all, 'detail'],
  detail: (id) => [...jobKeys.details(), id],
};

export const candidateListByJobKey = {
  all: (id) => ['candidateList', id],
};

export const companyKeys = {
  all: ['companies'],
};

export default cacheKey;
